"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var ContextMenuContainer_1 = require("./ContextMenuContainer");
var clsx_1 = __importDefault(require("clsx"));
var CHILD_STYLES = "flex flex-col shadow absolute bg-white rounded py-2 w-48";
var ITEM_STYLES = "flex relative hover:bg-gray-200 hover:bg-opacity-50";
var BUTTON_STYLES = "flex flex-row py-1 px-3 text-xs font-bold flex-grow";
var ICON_STYLES = "my-auto text-lochivar-default";
var LABEL_STYLES = "pl-2 text-sorbus-default flex-shrink-0";
/**
 * A context menu with overlay to dismiss itself when a user clicks outside of
 * the menu. Similar to a modal view but purely for menu navigsation.
 */
var ContextItem = function (_a) {
    var children = _a.children, icon = _a.icon, onClick = _a.onClick, disabled = _a.disabled, name = _a.name;
    var childMenu = (0, react_1.useRef)(null);
    var timeout = (0, react_1.useRef)();
    var _b = (0, react_1.useState)({ bottom: false, right: false }), alignment = _b[0], setAlignment = _b[1];
    var _c = (0, react_1.useState)(false), hover = _c[0], setHover = _c[1];
    var handleClick = function (e) {
        e.preventDefault();
        if (onClick) {
            onClick();
        }
    };
    var handleHover = function (active) { return function (e) {
        e.preventDefault();
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
        timeout.current = setTimeout(function () { return setHover(active); }, 350);
    }; };
    (0, react_1.useEffect)(function () {
        var _a;
        if (hover) {
            var r = (_a = childMenu.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            var bottom = r ? window.innerHeight < r.y + r.height : false;
            var right = r ? window.innerWidth < r.x + r.width : false;
            setAlignment({ bottom: bottom, right: right });
        }
    }, [setAlignment, hover]);
    return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: ITEM_STYLES, onMouseOver: handleHover(true), onMouseOut: handleHover(false) }, { children: [(0, jsx_runtime_1.jsxs)("button", __assign({ onClick: handleClick, className: BUTTON_STYLES, style: {
                    pointerEvents: disabled ? "none" : "all",
                    opacity: disabled ? 0.5 : 1,
                } }, { children: [icon ? ((0, jsx_runtime_1.jsx)("span", __assign({ className: ICON_STYLES }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, style: {
                                width: "20px",
                            } }, void 0) }), void 0)) : ((0, jsx_runtime_1.jsx)("i", { style: { width: "20px" } }, void 0)), (0, jsx_runtime_1.jsx)("span", __assign({ className: LABEL_STYLES }, { children: name }), void 0), children ? ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faChevronRight, style: {
                            width: "20px",
                        }, className: "my-auto ml-auto text-rose-darkest" }, void 0)) : null] }), void 0), hover && children ? ((0, jsx_runtime_1.jsx)(ContextMenuContainer_1.ContextMenuContainer, __assign({ className: (0, clsx_1.default)(CHILD_STYLES, alignment.bottom ? "bottom-0" : "top-0", alignment.right ? "right-100 -mr-1" : "left-100 -ml-1"), onClick: handleClick, onMouseOver: handleHover(true), onMouseOut: handleHover(false), ref: childMenu }, { children: children }), void 0)) : null] }), void 0));
};
exports.ContextItem = ContextItem;
